import { Component } from "@angular/core";

@Component({
  standalone:false,
  templateUrl: "./release-notes.component.html",
  styleUrls: ["./release-notes.component.scss"]
})
export class ReleaseNotesComponent {}
